export default function RectangleToolIcon({
    fillClassName,
}: {
    fillClassName: string;
}) {
    return (
        <svg
            width="16"
            height="14"
            viewBox="0 0 10 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.1778 5.29871H1.56456V1.05443H7.37627V3.83509L7.96457 3.97962L8.39408 4.08548V0.331787C8.39408 0.168937 8.26177 0.0366211 8.09892 0.0366211H0.841918C0.679068 0.0366211 0.546753 0.168937 0.546753 0.331787V6.02135C0.546753 6.1842 0.679068 6.31652 0.841918 6.31652H5.43021L5.36304 6.04171L5.17983 5.29871H5.1778Z"
                fill={fillClassName}
            />
            <path
                d="M9.2612 4.93027L8.40013 4.71653H8.39402L7.81794 4.572L7.37621 4.46208L5.88817 4.09567C5.86782 4.08956 5.84746 4.08752 5.8271 4.08752C5.67036 4.08752 5.54415 4.23612 5.58486 4.39897L5.80675 5.29668L5.95331 5.89312L6.05713 6.3145L6.09581 6.47328L6.41743 7.772C6.44797 7.89211 6.55382 7.96335 6.66171 7.96335C6.72481 7.96335 6.78792 7.94096 6.83881 7.89007L9.37927 5.34961C9.51769 5.21119 9.45255 4.97506 9.2612 4.92824V4.93027Z"
                fill={fillClassName}
            />
        </svg>
    );
}
